import { Check, Sparkles } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { CountdownTimer } from "@/components/landing/CountdownTimer";
import { CHECKOUT_URL } from "@/lib/site";

const FEATURES = ["300+ follow-along home workouts", "Personalized weekly plan", "Lazy-friendly nutrition guide", "Progress tracking & streaks", "Beginner modifications for every move", "New workouts every week"];

const PLANS = [
  { id: "monthly", name: "Monthly", price: "$14.99", per: "/month", note: "after your 7-day free trial", popular: false },
  { id: "annual", name: "Annual", price: "$99.99", per: "/year", note: "after your 7-day free trial", save: "Save 44% — just $8.33/mo", popular: true },
];

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="py-24 md:py-32 bg-slate-950 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <SectionHeading label="Start today" title="Try everything free for 7 days" sub="Full access to every workout and the complete fat-loss system. Cancel in one tap if it's not for you — you'll never be charged." />
      <Reveal className="mb-16">
        <p className="text-center text-sm uppercase tracking-[0.2em] font-bold text-slate-500 mb-6">This week's free trial offer ends in</p>
        <CountdownTimer />
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.id} delay={0.08 * i}>
            <div data-testid={`pricing-card-${plan.id}`} className={`relative h-full rounded-[2rem] p-8 md:p-10 border-2 transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 ${plan.popular ? "bg-white border-white text-slate-900 shadow-[0_24px_50px_rgb(255,255,255,0.06)]" : "bg-slate-900 border-slate-800 text-white shadow-[0_8px_30px_rgb(0,0,0,0.3)]"}`}>
              {plan.popular && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-blue-600 text-white text-xs font-bold px-4 py-1.5 shadow-lg">
                  <Sparkles size={13} /> MOST POPULAR
                </span>
              )}
              <h3 className={`font-display text-lg font-bold ${plan.popular ? "text-slate-500" : "text-slate-400"}`}>{plan.name}</h3>
              <div className="mt-3 flex items-end gap-1">
                <span data-testid={`pricing-price-${plan.id}`} className="font-display text-5xl font-black tracking-tight">{plan.price}</span>
                <span className={`pb-1.5 font-semibold ${plan.popular ? "text-slate-500" : "text-slate-400"}`}>{plan.per}</span>
              </div>
              <p className={`mt-1 text-sm font-medium ${plan.popular ? "text-slate-500" : "text-slate-400"}`}>{plan.note}</p>
              {plan.save && <p className="mt-2 text-sm font-bold text-blue-600">{plan.save}</p>}
              <ul className="mt-7 space-y-3.5">
                {FEATURES.map((f) => (
                  <li key={f} className={`flex items-start gap-3 text-sm font-medium ${plan.popular ? "text-slate-700" : "text-slate-300"}`}>
                    <Check size={18} className={`${plan.popular ? "text-blue-600" : "text-blue-400"} shrink-0 mt-0.5`} /> {f}
                  </li>
                ))}
              </ul>
              <a data-testid={`pricing-cta-${plan.id}`} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer"
                className={`mt-9 w-full inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 active:translate-y-0 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:outline-none focus-visible:ring-offset-2 ${plan.popular ? "bg-blue-600 text-white shadow-[0_8px_20px_0_rgb(37,99,235,0.4)] hover:shadow-[0_12px_25px_0_rgb(37,99,235,0.5)]" : "bg-white text-slate-900 hover:bg-slate-200"}`}>
                Start 7-Day Free Trial
              </a>
              <p className="mt-4 text-center text-xs text-slate-500">No charge today · Cancel anytime</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
